import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Result, Button } from "antd";
import { useAuth } from "../../context/AuthContext";

const AdminRoute = () => {
  const { user, isAdmin } = useAuth();
  const location = useLocation();

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!isAdmin) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-slate-50">
        <Result
          status="403"
          title="403 - Forbidden"
          subTitle="You do not have permission to access the admin portal."
          extra={
            <Button type="primary" href="/">
              Back to dashboard
            </Button>
          }
        />
      </div>
    );
  }

  return <Outlet />;
};

export default AdminRoute;
